module.exports = __webpack_public_path__ + "images/Progyny-3add54.png";